import * as Actions from '../../actions';

const initialState = { data: null };

const listSubProcessorReducer = function (state = initialState, action) {
    switch (action.type) {
        case Actions.GET_SUB_PROCESSORS_LIST_DETAILS:
            return { ...state, data: { ...action.payload } };
        default:
            return state;
    }
};

export default listSubProcessorReducer;
